import React from "react";

export function StatCard({ icon, label, value }) {
  return (
    <div className="bg-card border border-border rounded-sm p-5">
      <div className="flex items-center gap-2 text-muted-foreground text-xs font-bold uppercase tracking-wider">
        <span className="text-primary">{icon}</span> {label}
      </div>
      <div className="font-display text-3xl font-medium mt-2 tabular-nums">{value}</div>
    </div>
  );
}

export function CoverageCard({ label, value, total, pct, color }) {
  const barClass = color === "primary" ? "bg-primary" : color === "secondary" ? "bg-secondary" : "bg-foreground";
  return (
    <div className="bg-accent/20 border border-border rounded-sm p-3">
      <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">{label}</div>
      <div className="font-display text-xl tabular-nums font-medium mt-1">{value.toLocaleString("fr-FR")}</div>
      <div className="text-[10px] text-muted-foreground">{pct}% de {total.toLocaleString("fr-FR")}</div>
      <div className="h-1 bg-accent rounded-sm overflow-hidden mt-2">
        <div className={`h-full ${barClass}`} style={{ width: `${Math.min(100, pct)}%` }} />
      </div>
    </div>
  );
}

export function MiniStat({ label, value, hint }) {
  return (
    <div className="bg-accent/20 border border-border rounded-sm p-3">
      <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">{label}</div>
      <div className="font-display text-xl tabular-nums font-medium mt-1">{(value || 0).toLocaleString("fr-FR")}</div>
      {hint && <div className="text-[10px] text-muted-foreground">{hint}</div>}
    </div>
  );
}
